import React from 'react';

const PagesTemplate = ({ rowData }) => {
  if (rowData?.entry_type === 'folder') {
    return <span className="text-muted">-</span>;
  }

  const pages = rowData?.page_count;
  return (
    <span className="text-muted">
      <span className="p-column-title text-break">Pages</span>
      {pages ? pages : '-'}
    </span>
  );
};

export default PagesTemplate;
